/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SendCommercialOrderWithoutCrefoNumber$Params {
  customerGUID: string;
  companyName: string;
  country: string;
  postCode: string;
  city: string;
  street?: string;
  houseNumber?: number;
  houseNumberAffix?: string;
  orderSpecifyingText?: string;
}

export function sendCommercialOrderWithoutCrefoNumber(http: HttpClient, rootUrl: string, params: SendCommercialOrderWithoutCrefoNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, sendCommercialOrderWithoutCrefoNumber.PATH, 'post');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
    rb.query('companyName', params.companyName, {});
    rb.query('country', params.country, {});
    rb.query('postCode', params.postCode, {});
    rb.query('city', params.city, {});
    rb.query('street', params.street, {});
    rb.query('houseNumber', params.houseNumber, {});
    rb.query('houseNumberAffix', params.houseNumberAffix, {});
    rb.query('orderSpecifyingText', params.orderSpecifyingText, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

sendCommercialOrderWithoutCrefoNumber.PATH = '/crefo/order/commercial/without-crefo';
